import { CLEAR_DEVICE_FILTER, SET_DEVICE_FILTER, SET_DEVICE_PAGE_NUMBER } from '../types';

const initialState = {
    deviceFilter: null,
    pageNumber: 1,
};

const filterDeviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DEVICE_FILTER:
            return {
                ...state,
                deviceFilter: action.payload,
            };
        case SET_DEVICE_PAGE_NUMBER:
            return {
                ...state,
                pageNumber: action.payload,
            };
        case CLEAR_DEVICE_FILTER:
            return {
                ...state,
                deviceFilter: null,
                pageNumber: 1,
            };
        default:
            return state;
    }
};

export default filterDeviceReducer;
